(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-item"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('noir-card-rating')) {
            customElements.define('noir-card-rating', class extends HTMLElement {
              static statistics;
              connectedCallback() {
                const component = this;
                const sourceId = this.dataset.sourceProductId;
                if (!this.constructor.statistics) {
                  const url = 'https://bk-reviews-shopify-backend-production.up.railway.app/reviews/' + encodeURIComponent(this.dataset.store) + '/metadata/collection/?product_ids=' + encodeURIComponent(sourceId);
                  this.constructor.statistics = fetch(url, {credentials: 'omit', signal: AbortSignal.timeout(8000)})
                    .then(response => {
                      if (!response.ok) throw new Error('Review statistics unavailable');
                      return response.json();
                    });
                }
                this.constructor.statistics.then(rows => {
                  const row = Array.isArray(rows) && rows.find(item => String(item.product_id) === sourceId);
                  if (!row || !component.isConnected) return;
                  const rating = Number(row.average_rating);
                  const count = Number(row.qty_general_rating);
                  if (!Number.isFinite(rating) || rating < 0 || rating > 5 || !Number.isInteger(count) || count < 0) return;
                  const formatted = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {maximumFractionDigits: 1, minimumFractionDigits: 1}).format(rating);
                  component.querySelector('.noir-card-reviews__fill').style.width = (rating / 5 * 100) + '%';
                  component.querySelector('.noir-card-reviews__stars').setAttribute('aria-label', component.dataset.ratingLabel.replace('__RATING__', formatted));
                  component.querySelector('.noir-card-reviews__value').textContent = formatted;
                  component.querySelector('.noir-card-reviews__count').textContent = component.dataset.countLabel.replace('__COUNT__', String(count));
                  component.dataset.reviewStatus = 'updated';
                }).catch(() => { component.dataset.reviewStatus = 'fallback'; });
              }
            });
          }
  } catch(e) { console.error(e); }
})();

})();
